import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import axios from "axios";
import VueAxios from "vue-axios";
import VueMeta from "vue-meta";

Vue.config.productionTip = false;
Vue.use(VueAxios, axios);
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true,
});

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
